module.exports = "./img/5d0de8ddec6a863b3cfbc4a593bea8d2.jpg";